import { create } from 'zustand';
import type { User } from 'firebase/auth';
import type { UserProfile } from '@/types';

export type AuthStatus = 'loading' | 'signedIn' | 'signedOut';

interface AuthState {
  status: AuthStatus;
  user: User | null;
  profile: UserProfile | null;
  /** null = admin claim not resolved yet */
  isAdmin: boolean | null;
  setUser: (user: User | null) => void;
  setProfile: (profile: UserProfile | null) => void;
  setIsAdmin: (isAdmin: boolean) => void;
}

export const useAuthStore = create<AuthState>((set) => ({
  status: 'loading',
  user: null,
  profile: null,
  isAdmin: false,
  setUser: (user) =>
    set(
      user
        ? { user, status: 'signedIn', isAdmin: null }
        : { user: null, status: 'signedOut', profile: null, isAdmin: false }
    ),
  setProfile: (profile) => set({ profile }),
  setIsAdmin: (isAdmin) => set({ isAdmin }),
}));
